export enum PortalIds {
  App = 'app-portal',
  TopNotifications = 'notification-portal-top',
  BottomNotifications = 'notification-portal-bottom',
}
